import React, {useRef, useState} from "react";
import styles from "./PrimaryCollapsibleSection.module.css";
import {Arrow} from "../../arrow/Arrow";

interface SectionProps {
    title: string;
    openByDefault?: boolean;
    children: React.ReactNode;
}

export const PrimaryCollapsibleSection: React.FC<SectionProps> = ({
                                                                      title,
                                                                      openByDefault = false,
                                                                      children
                                                                  }) => {

    const [isOpen, setIsOpen] = useState(openByDefault);
    const contentRef = useRef<HTMLDivElement>(null)

    return <div className={styles.wrapper}>
        <div className={styles.titleWrapper} onClick={event => event.stopPropagation()}>
            <span className={styles.title}>{title}</span>
            <Arrow isUp={isOpen} onClick={setIsOpen}/>
        </div>
        <div
            className={`${styles.childrenWrapper} ${isOpen ? styles.open : ""}`}
            ref={contentRef}
            style={{maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : "0"}}>
            {children}
        </div>
    </div>
}
